import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { DropdownSelectMapOption } from "@bitwarden/web-vault/app/directives/dropdown.directive";

export type SymbolGroup = "cash" | "securities" | "realEstate" | "personalProperty" | "other";
export enum SymbolGroupEnum {
  cash = "cash",
  securities = "securities",
  realEstate = "realEstate",
  personalProperty = "personalProperty",
  other = "other",
}

/** Fixed display order for grouped symbol lists and the summary strip. */
export const SymbolGroupOrder: SymbolGroup[] = [
  SymbolGroupEnum.cash,
  SymbolGroupEnum.securities,
  SymbolGroupEnum.realEstate,
  SymbolGroupEnum.personalProperty,
  SymbolGroupEnum.other,
];

export const SymbolGroupIcon: Record<SymbolGroup, string> = {
  cash: "wallet",
  securities: "stock-account",
  realEstate: "home",
  personalProperty: "warehouse",
  other: "other-account",
};

/** i18n key (messages.json) for each group's display label. */
export const SymbolGroupI18nKey: Record<SymbolGroup, string> = {
  cash: "symbolGroupCash",
  securities: "symbolGroupSecurities",
  realEstate: "symbolGroupRealEstate",
  personalProperty: "symbolGroupPersonalProperty",
  other: "symbolGroupOther",
};

/** Dropdown options for selecting a symbol's group, in the fixed {@link SymbolGroupOrder}. */
export function symbolGroupDropdownOptions(i18n: I18nService): DropdownSelectMapOption[] {
  return SymbolGroupOrder.map((group) => ({
    realValue: group,
    optionDisplayValue: i18n.t(SymbolGroupI18nKey[group]),
    selectedDisplayValue: i18n.t(SymbolGroupI18nKey[group]),
  }));
}
